import { assistanceKey, assistanceStackKey, dashboardKey, dashboardStackKey, healthProfileKey, libraryKey, libraryStackKey, privateKey, healthStackKey as profileStackKey, settingKey, settingStackKey } from '../../constants/routeKeys';
import { concatPath } from '../../utils/links/concatPath';
import { router } from 'expo-router';
import { useStores } from '../useStores';
import { userDrawerLabelPropsKey } from './useDrawerLabel';

export const defaultKeyFn = (key: userDrawerLabelPropsKey) => {
  switch (key) {
  case dashboardStackKey: return dashboardKey;
  case libraryStackKey: return libraryKey;
  case assistanceStackKey: return assistanceKey;
  case profileStackKey: return healthProfileKey;
  case settingStackKey: return settingKey;
  default : return '';
  }
};

export const useNavigationOnPress = (labelKey: userDrawerLabelPropsKey) => {

  const {user} = useStores();
  const onPress = () => {

    if(labelKey === libraryStackKey) {
      user.cancelTabSelected();
    }
    router.navigate(concatPath([privateKey, labelKey,defaultKeyFn(labelKey)], -1));
  };

  return {onPress};

};
